import { useState, useEffect } from "react";
import { NavLink, useParams} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import DatosCabezaFamilia from '../DatosCabezaFamilia';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuCaracterizacion from "../Componentes/MenuCaracterizacion";
import { useAuth } from '../../../Auth/AuthContext';

registerLocale('es', es);
setDefaultLocale('es');

const Integrante = ({ register, index, defaultValues, ordenidentificacion, nodeclaracion }) => {
    const today = new Date().toISOString().split('T')[0];

    return (
    <div style={{borderBlock:'2px solid gray'}}>
        <h5><b>Nombre:</b> {defaultValues.nombre}</h5>
        <div className="row" >
            <div className="col-md-6">
                <p><b>Identificacion:</b> {defaultValues.per_idpersona}, <b>parentesco:</b> {defaultValues.par_parentesco}</p>
            </div>
        </div>
        <input hidden id={`idPersona-${index}`} {...register(`integrantes.${index}.idPersona`)} defaultValue={defaultValues.per_idpersona}/>
        {nodeclaracion !== '' && defaultValues.per_incluido === '1' && <div className="row">
            <div className="col-md-3">
                <div className="form-group">
                    <label htmlFor={`ididentificacion-${index}`}>Tipo documento</label>
                    <select id={`ididentificacion-${index}`} {...register(`integrantes.${index}.ididentificacion`)} className="form-control">
                        <option value="">Seleccionar</option>
                        {ordenidentificacion.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.tipTipoidentificacion}-{option.tipDescripcion}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label htmlFor={`fechacita-${index}`}>Fecha remitido:</label>
                    <input type="date" id={`fechacita-${index}`} {...register(`integrantes.${index}.fechacita`)} defaultValue={today} min={today} className="form-control"/>
                </div>
            </div>
            <div className="col-md-3 alfinal" >
                <div className="form-group alfinal">
                    Remitir: <input type="checkbox" id={`remitir-${index}`} {...register(`integrantes.${index}.remitir`)} />
                </div>
            </div>
            <hr />
        </div>}
        {nodeclaracion === '' || defaultValues.per_incluido !== '1' && <p>Falta numero de declaracion o no esta incluido</p> }
    </div>
    )
  }



export default function RemisionRegistraduria(){
    const { token, rol, user, sedeActual } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const { handleSubmit, register, setValue, reset } = useForm();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const [nodeclaracion, setNodeclaracion] = useState('');
    const [integrantes, setIntegrantes] = useState([]);
    const [ordentipoidentificacion, setOrdentipoidentificacion] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    useEffect(() => {
    
        const fetchData = async () => {
            const url = '/remisiones/crearformularioremisionregistraduria';
            const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user };
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setNodeclaracion(result.cabezafamilia.cab_nodeclaracion);
                if (Array.isArray(result.integrantesdto)) {
                    setIntegrantes(result.integrantesdto);
                } else {
                    console.error('Invalid data format for integrantesdto:', result.integrantesdto);
                }
                if (Array.isArray(result.ordentipoidentificacion)) {
                    setOrdentipoidentificacion(result.ordentipoidentificacion);
                } else {
                    console.error('Invalid data format for ordentipoidentificacion:', result.ordentipoidentificacion);
                }
                setValue('usrId', user );
                setValue('cabIdcabezafamilia', idCabezaFamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
            
            
        };
        fetchData();
    }, []);
    const onSubmit = async (data) => {
        data.integrantes = data.integrantes.filter((item) => item.remitir)
        let mensaje = '';
        for (const integrante of data.integrantes) {
            if (integrante.fechacita === '') {
                mensaje += 'La fecha de remision es obligatoria para los integrantes seleccionados. ';
            }
            if (integrante.ididentificacion === '') {
                mensaje += 'El tipo de documento es obligatorio para los integrantes seleccionados. ';
            }
        }
        if (mensaje !== '') {
            Mensaje('Remision registraduria', mensaje);
            return;
        }
        setCargando(true);
        let url;
        url = '/remisiones/remisionarpersonaregistraduria';
        data.sede = sedeActual;
        if(data.integrantes.length > 0){
            try {
                const response = await apiService.post(url, data, token);
                if(response.status === 200){
                    Mensaje('Remision registraduria', JSON.stringify(response.data));
                    reset({
                        atencionesfields: []
                      });
                }
            } catch (error) {
                if(error.status === 422){
                    Mensaje('Remision registraduria', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Remision registraduria', JSON.stringify(error.response.data));
                }
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        }else{
            Mensaje('Remision registraduria', 'No ha seleccionado persona a remitir.');
        }
        
    
    };

    

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Registrar remisiones registraduria</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={"/"} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Remision registraduria</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                    <div className="card card-info">
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-header">
                                <h3 className="card-title">Registrar remision registraduria</h3>
                            </div>
                            
                            <div className="card-body">
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                {integrantes.map((integrante, index) => (
                                   <Integrante 
                                        key={index} 
                                        register={register} 
                                        index={index} 
                                        defaultValues={integrante}
                                        ordenidentificacion={ordentipoidentificacion}
                                        nodeclaracion = {nodeclaracion}/>
                                ))}
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary">Remitir</button>
                            </div>
                        </form>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            </section>

        </div>
    );
}